module.exports = __webpack_public_path__ + "img/dsci0069.720fd170.jpg";